"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeOutboundLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _i18n = require("@wordpress/i18n");
var _A11yNotice = require("./tests/A11yNotice");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* External dependencies */

/* Internal dependencies */

/**
 * Makes an anchor component into an outbound link that opens in a new tab.
 *
 * @param {ReactElement} Component The anchor component to be wrapped.
 *
 * @returns {ReactElement} The OutboundLink component.
 */
const makeOutboundLink = (Component = "a") => {
  /**
   * OutboundLink component.
   */
  class OutboundLink extends _react.default.Component {
    /**
     * Constructs the OutboundLink component.
     *
     * @param {Object} props The props for the snippet preview example.
     */
    constructor(props) {
      super(props);
      this.isYoastLink = this.isYoastLink.bind(this);
    }

    /**
     * Determines if a certain URL points to Yoast.
     *
     * @param {string} url The URL to test.
     * @returns {boolean} Whether or not the URL points to Yoast.
     */
    isYoastLink(url) {
      return /yoast\.com|yoast\.test|yoa\.st/.test(url);
    }

    /**
     * Renders the component.
     *
     * @returns {ReactElement} The rendered component.
     */
    render() {
      if (!this.props.href) {
        return null;
      }
      const isYoastLink = this.isYoastLink(this.props.href);
      /*
       * Set the target="_blank" and rel attributes. When a link doesn't point
       * to Yoast, we want just a "noopener" rel attribute value.
       * Instead, when a link does point to Yoast, we use the rel prop which
       * is null by default so it doesn't render. This way, it can be
       * overridden setting the prop, if necessary.
       */
      const newProps = Object.assign({}, this.props, {
        target: "_blank",
        rel: isYoastLink ? this.props.rel : "noopener"
      });
      // Use React.createElement instead of JSX because it can accept a string as a component parameter.
      return _react.default.createElement(Component, newProps, this.props.children, _react.default.createElement(_A11yNotice.A11yNotice, null, /* translators: Hidden accessibility text. */
      (0, _i18n.__)("(Opens in a new browser tab)", "wordpress-seo")));
    }
  }
  OutboundLink.propTypes = {
    children: _propTypes.default.oneOfType([_propTypes.default.node]),
    href: _propTypes.default.string,
    rel: _propTypes.default.string
  };
  OutboundLink.defaultProps = {
    children: null,
    href: null,
    rel: null
  };
  return OutboundLink;
};
exports.makeOutboundLink = makeOutboundLink;